import { css, type Theme } from "@emotion/react";

export const keyboardHover = (theme: Theme) => css`
  background-color: ${theme.system.backgroundMuted};
`;

export const row = (theme: Theme) => css`
  display: flex;
  align-items: center;
  height: unset;
  text-align: left;
  padding-left: 1rem;
  padding-right: 0.625rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;

  &:hover {
    background-color: ${theme.system.backgroundMuted};

    > div > svg {
      visibility: unset;
    }
  }

  &&&:not(:last-of-type) {
    margin-bottom: 0;
  }
`;

export const hideRemoveIcon = css`
  > div > svg {
    visibility: hidden;
  }
`;

export const icon = (theme: Theme) => css`
  display: inline-block;
  color: ${theme.text.subdued};
`;

export const text = css`
  display: inline;
  word-break: break-word;
`;

export const button = css`
  display: flex;
  padding: 0;
  flex: 1 1 auto;
  align-items: center;
`;

export const textWrapper = css`
  margin-left: 0.6rem;
`;

export const deleteWrapper = (theme: Theme) => css`
  cursor: pointer;
  flex: 0 0 1.5rem;
  display: flex;
  justify-content: center;
  padding: 0.2rem 0;
  border-radius: 0.5rem;
  margin-left: 0.5rem;

  &:hover {
    background-color: ${theme.system.backgroundMutedHover};
  }
`;
